import React, { Component } from 'react'
import { inject } from 'mobx-react'
import { graphql } from 'react-apollo'
import { injectIntl } from 'react-intl'
import { EventFormWrapper } from '~/styles'
import { Form, Button, Select, Input, Modal } from 'antd'
import createEventFormMutation from '~/App/graphql/mutations/createEventForm.gql'
import _get from 'lodash/get'
import Reaptcha from 'reaptcha'
import Textarea from 'react-textarea-autosize'
import localeGet from '~/App/utils/localeGet'
const formItemLayout = {}
const tailFormItemLayout = {
  wrapperCol: {
    xs: {
      span: 24,
      offset: 0,
    },
    sm: {
      span: 24,
      offset: 0,
    },
  },
}
@Form.create()
@inject('i18n')
@graphql(createEventFormMutation, { name: 'createEventFormMutation' })
@injectIntl
class EventForm extends Component {
  submitting = false
  captchaVerify = false
  alertError = (err) => {
    const { graphQLErrors } = err
    if (graphQLErrors) {
      graphQLErrors.forEach(error => {
        Modal.error({
          title: 'Error',
          content: error.message
        })
      })
    } else {
      Modal.error({
        title: 'Error',
        content: err.message
      })
    }
  }
  onCaptchaVerify = () => {
    this.captchaVerify = true
  }
  handleSubmit = e => {
    e.preventDefault()
    const { form: {validateFieldsAndScroll}, createEventFormMutation } = this.props
    validateFieldsAndScroll({ force: true }, (err, record) => {
      if (!err) {
        if (!this.submitting && this.captchaVerify) {
          this.submitting = false
          
          createEventFormMutation({
            variables: { record: record.eventForm }
          }).then(res => {
            window.scrollTo(0, 0)
            this.props.history.push(
              `/eventForm/success`
            )
          }).catch(e => {
            this.alertError(e)
            this.submitting = false
          })
        }
      }
    })
  }
  render () {
    const {
      form,
      i18n: { locale },
      intl,
      data
    } = this.props
    const {
      getFieldDecorator
    } = form
    const requiredFieldMessage = intl.formatMessage({
      id: 'app.requiredFieldMessage',
      defaultMessage: 'This field is required'
    })
    const eventTypes = [
      {
        key: 'normal',
        name: {
          th: 'วิ่งในงาน',
          en: 'Race location'
        }
      }, {
        key: 'vr',
        name: {
          th: 'วิ่งที่ไหนก็ได้ (VR)',
          en: 'Virtual run'
        }
      }
    ]

    const contactNameDecorator = getFieldDecorator(`eventForm.contactName`, {
      initialValue: _get(data, 'eventForm.contactName'),
      rules: [{ required: true,
        message: requiredFieldMessage }]
    })
    const emailDecorator = getFieldDecorator(`eventForm.email`, {
      initialValue: _get(data, 'eventForm.email'),
      rules: [{ required: true,
        message: requiredFieldMessage }]
    })
    const telephoneDecorator = getFieldDecorator(`eventForm.telephone`, {
      initialValue: _get(data, 'eventForm.telephone'),
      rules: [{ required: true,
        message: requiredFieldMessage }]
    })
    const eventNameDecorator = getFieldDecorator(`eventForm.eventName`, {
      initialValue: _get(data, 'eventForm.eventName'),
      rules: [{ required: true,
        message: requiredFieldMessage }]
    })
    const eventTypeDecorator = getFieldDecorator(`eventForm.eventType`, {
      initialValue: 'vr',
      rules: [{ required: true,
        message: requiredFieldMessage }]
    })
    const participantLimitDecorator = getFieldDecorator(`eventForm.participantLimit`, {
      initialValue: _get(data, 'eventForm.participantLimit')
    })
    const detailsDecorator = getFieldDecorator(`eventForm.details`, {
      initialValue: _get(data, 'eventForm.details')
    })
    return <EventFormWrapper className="EventRegisterPage">
      <div className="innerEventRegisterPage">
        <Form className="dividedBox">
          <Input.Group>
          <h1>เทคโนโลยีที่ได้รับ</h1>
            <Form.Item
              {...tailFormItemLayout}
            >
                - server ความเร็วสูง<br/>
                - ระบบรับสมัครออนไลน์<br/>
                - ระบบรายงานข้อมูลผู้สมัคร<br/>
                - ระบบ E-mail แจ้งผลการสมัครและผลการชำระเงินสำหรับนักวิ่ง<br/>
                - ระบบการค้นหารูปภาพด้วยเลขบิบ <b>(Bib Search System)</b> <br/>
                - ระบบการค้นหารูปภาพด้วยใบหน้า <b>(Face Search System)</b> <br/>
                - โปรโมทงานในลักษณะ Event บน Facebook Fanpage &nbsp;
                  <a href="https://www.facebook.com/thaidotrun/" 
                     target="_blank" 
                     without="true" 
                     rel="noopener noreferrer"
                     >
                     ThaiRun ฮับความสุขนักวิ่ง</a> (ฟรี) จำนวน 1 ครั้ง<br/>
                - โพสต์ประชาสัมพันธ์งานวิ่ง บน Facebook Fanpage &nbsp;
                  <a href="https://www.facebook.com/thaidotrun/" 
                     target="_blank" 
                     without="true" 
                     rel="noopener noreferrer"
                     >
                     ThaiRun ฮับความสุขนักวิ่ง</a> (ฟรี) จำนวน 2 ครั้ง<br/>
                - ระบบชำระเงินออนไลน์ผ่านช่องทางต่างๆ <br/>
                (บัตรเครดิต/เดบิต, Internet Banking, Linepay, ชำระเงินสดผ่าน One Stop Service ที่ Tesco Lotus)<br/>
            </Form.Item>
            <h1>ค่าใช้จ่าย</h1>
            <Form.Item
              {...tailFormItemLayout}
            >
                ระบบไม่มีค่าแรกเข้า<br/>
                ค่าธรรมเนียมการสมัคร 7% <b>(รวมค่าธรรมเนียมธนาคาร และภาษีมูลค่าเพิ่มแล้ว)</b> <br/>
                คิดราคาขั้นต่ำที่นักวิ่ง 500 คน<br/>
            </Form.Item>
            <h1>
              กรอกข้อมูลงานวิ่ง<br/>
              <span style={{color: 'red'}}>(เฉพาะผู้จัดงานที่สนใจจัดงานวิ่งเท่านั้น)</span>
            </h1>
            <Form.Item
              label={{ en: 'Contact name', th: 'ชื่อผู้ติดต่อ' }[locale]}
              {...formItemLayout}
            >
              {contactNameDecorator(<Input />)}
            </Form.Item>
            <Form.Item
              label={{ en: 'Contact email', th: 'อีเมล' }[locale]}
              {...formItemLayout}
            >
              {emailDecorator(<Input />)}
            </Form.Item>
            <Form.Item
              label={{ en: 'Contact number', th: 'เบอร์โทร' }[locale]}
              {...formItemLayout}
            >
              {telephoneDecorator(<Input />)}
            </Form.Item>
            <Form.Item
              label={{ en: 'Event name', th: 'ชื่องาน' }[locale]}
              {...formItemLayout}
            >
              {eventNameDecorator(<Input />)}
            </Form.Item>
            <Form.Item
              label={{ en: 'Event Type', th: 'ประเภทงาน' }[locale]}
              {...formItemLayout}
            >
              {eventTypeDecorator(
                <Select>
                  {eventTypes.map(({key, name}) =>
                    <Select.Option
                      key={key}
                      value={key}
                    >
                      {localeGet(name, '', locale)}
                    </Select.Option>
                  )}
                </Select>
              )}
            </Form.Item>
            <Form.Item
              label={{ en: 'Participant limit', th: 'จำนวนนักวิ่งโดยประมาณ' }[locale]}
              {...formItemLayout}
            >
              {participantLimitDecorator(<Input />)}
            </Form.Item>
            <Form.Item
              label={{ en: 'รายละเอียดอื่นๆ', th: 'รายละเอียดอื่นๆ' }[locale]}
              {...formItemLayout}
            >
              {detailsDecorator(<Textarea style={{width: '100%'}}/>)}
            </Form.Item>
            <Form.Item
              label={{ en: `กรุณาติ๊กถูกว่าฉันไม่ใช่บ็อต (I'm not a robot)`, th: `กรุณาติ๊กถูกว่าฉันไม่ใช่บ็อต (I'm not a robot)` }[locale]}
              {...formItemLayout}
            >
              <Reaptcha key="reaptcha" sitekey="6LcLo3cUAAAAAMpiICx4aNjtFc2pu3wiCrZi9buK" onVerify={this.onCaptchaVerify} />
            </Form.Item>
            <Form.Item
              {...tailFormItemLayout}
            >
              <Button key="submit" icon="mail" onClick={this.handleSubmit} loading={this.submitting} type="primary">
                ตกลง
              </Button>
            </Form.Item>
          </Input.Group>
        </Form>
      </div>
    </EventFormWrapper>
  }
}

export default EventForm



// WEBPACK FOOTER //
// ./src/App/pages/EventForm/EventForm.js